import { render, staticRenderFns } from "./AttachmentActions.vue?vue&type=template&id=054f2de8&scoped=true"
import script from "./AttachmentActions.vue?vue&type=script&lang=js"
export * from "./AttachmentActions.vue?vue&type=script&lang=js"
import style0 from "./AttachmentActions.vue?vue&type=style&index=0&id=054f2de8&prod&lang=less&scoped=true"
import style1 from "./AttachmentActions.vue?vue&type=style&index=1&id=054f2de8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054f2de8",
  null
  
)

export default component.exports